import { render, staticRenderFns } from "./lianqunIndex.vue?vue&type=template&id=12550015"
import script from "./lianqunIndex.vue?vue&type=script&lang=js"
export * from "./lianqunIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports